var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCloudAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2242 48.312L24.4402 43.56L49.0802 57.792L40.8722 62.536L16.2242 48.312Z",
    fill: "url(#paint0_linear_720_1487)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9278 26.32C48.8308 26.1525 48.6933 26.0122 48.5278 25.912L47.6478 25.4L24.8638 12.248C24.8066 12.2067 24.7399 12.1807 24.67 12.1723C24.6 12.1639 24.5291 12.1734 24.4638 12.2L16.3758 16.864C16.2878 16.92 18.1038 39.88 18.1038 39.88L21.5438 42.112L49.0078 26.48C48.986 26.4243 48.9592 26.3708 48.9278 26.32Z",
    fill: "url(#paint1_linear_720_1487)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9277 49.9601C48.9914 49.9199 49.0425 49.8625 49.075 49.7946C49.1076 49.7267 49.1203 49.6509 49.1117 49.5761V26.9121C49.1067 26.7625 49.0713 26.6155 49.0077 26.4801L21.5437 42.1121L40.8397 54.6241L48.9277 49.9601Z",
    fill: "url(#paint2_linear_720_1487)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9277 49.9601C48.9914 49.9199 49.0425 49.8625 49.075 49.7946C49.1076 49.7267 49.1203 49.6509 49.1117 49.5761V26.9121C49.1067 26.7625 49.0713 26.6155 49.0077 26.4801L21.5437 42.1121L40.8397 54.6241L48.9277 49.9601Z",
    fill: "url(#paint3_linear_720_1487)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5037 25.1199C37.5159 25.239 37.5593 25.3528 37.6295 25.4497C37.6998 25.5466 37.7943 25.6233 37.9037 25.6719C38.2029 25.8219 38.533 25.8999 38.8677 25.8999C39.2024 25.8999 39.5325 25.8219 39.8317 25.6719C39.9406 25.6215 40.0343 25.5431 40.1032 25.4448C40.172 25.3464 40.2136 25.2316 40.2237 25.1119V14.6159C40.2237 10.3039 36.9037 5.01594 32.6557 2.55994C30.2557 1.15194 27.8557 0.959943 26.0797 1.93594C24.5597 2.80794 23.6797 4.48794 23.6797 6.64794V17.1999C23.6905 17.3204 23.7333 17.4358 23.8036 17.5343C23.8739 17.6327 23.9692 17.7106 24.0797 17.7599C24.3775 17.9098 24.7063 17.9878 25.0397 17.9878C25.3731 17.9878 25.7019 17.9098 25.9997 17.7599C26.1092 17.7093 26.2036 17.631 26.2737 17.5328C26.3439 17.4347 26.3873 17.32 26.3997 17.1999V6.64794C26.356 6.19839 26.4287 5.74515 26.6108 5.33183C26.793 4.91851 27.0784 4.55902 27.4397 4.28794C28.3037 3.79194 29.7437 4.02394 31.2957 4.91994C34.6637 6.86394 37.5037 11.3199 37.5037 14.6159V25.1199Z",
    fill: "url(#paint4_linear_720_1487)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4483 30.5759L39.5683 30.0719L16.8003 16.9119C16.7448 16.8636 16.6755 16.8339 16.6023 16.8269C16.529 16.82 16.4554 16.8362 16.3918 16.8733C16.3282 16.9104 16.2779 16.9665 16.2478 17.0337C16.2178 17.1009 16.2096 17.1758 16.2243 17.2479V39.9119C16.2323 40.122 16.2958 40.3262 16.4083 40.5039C16.5025 40.6708 16.6373 40.8111 16.8003 40.9119L39.5683 54.0719L40.4483 54.5759C40.5039 54.6171 40.5692 54.6432 40.638 54.6516C40.7067 54.6601 40.7764 54.6505 40.8403 54.6239C40.9034 54.585 40.9541 54.5291 40.9867 54.4625C41.0193 54.396 41.0323 54.3216 41.0243 54.2479V31.5759C41.0127 31.3759 40.9546 31.1814 40.8546 31.0078C40.7546 30.8342 40.6155 30.6863 40.4483 30.5759Z",
    fill: "url(#paint5_linear_720_1487)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4002 33.304C30.3651 32.6794 30.1839 32.0717 29.8713 31.5299C29.5587 30.988 29.1233 30.527 28.6002 30.184C27.6002 29.608 26.7922 30.08 26.7922 31.224C26.8221 31.9409 27.0551 32.6345 27.4642 33.224L26.7922 37.472L30.4002 39.552L29.7282 34.536C29.957 34.4291 30.1455 34.2519 30.2664 34.0302C30.3873 33.8086 30.4342 33.5541 30.4002 33.304Z",
    fill: "url(#paint6_linear_720_1487)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1277 30.808C41.0018 30.5956 40.8261 30.4172 40.6157 30.288L39.7357 29.784L16.9437 16.624L16.8637 16.584L16.3757 16.864C16.4203 16.8521 16.4672 16.8521 16.5117 16.864C16.6029 16.8658 16.6917 16.8935 16.7677 16.944L39.5677 30.072L40.4477 30.576C40.6091 30.6788 40.7435 30.8187 40.8397 30.984C40.8397 30.984 40.8797 31.056 40.9037 31.096L41.1917 30.928L41.1277 30.808Z",
    fill: "url(#paint7_linear_720_1487)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_720_1487",
    x1: 22.3842,
    y1: 58.976,
    x2: 42.9202,
    y2: 47.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_720_1487",
    x1: 13.8638,
    y1: 32.544,
    x2: 42.8558,
    y2: 15.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_720_1487",
    x1: 22.8717,
    y1: 12.8081,
    x2: 47.1037,
    y2: 54.7761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#ABABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8D8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_720_1487",
    x1: 21.5437,
    y1: 40.5521,
    x2: 49.1117,
    y2: 40.5521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_720_1487",
    x1: 684.943,
    y1: 796.976,
    x2: 684.943,
    y2: 41.6262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_720_1487",
    x1: 19.6643,
    y1: 35.7439,
    x2: 41.2963,
    y2: 35.7439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_720_1487",
    x1: 26.1762,
    y1: 36.368,
    x2: 31.0562,
    y2: 33.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8D8D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_720_1487",
    x1: 16.4877,
    y1: 16.68,
    x2: 42.1597,
    y2: 31.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "white",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FDFDFD",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FBFBFB",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F7F7F7",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F3F3F3",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EDEDED",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#E6E6E6",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#DFDFDF",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D6D6D6",
    stopOpacity: 0.13
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D0D0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCloudAccess);
export default __webpack_public_path__ + "static/media/no_cloud_access.76ee30ceaa1fe7f70d73db699d9a00cb.svg";
export { ForwardRef as ReactComponent };